import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ChatWidget from './components/AIChat/ChatWidget';
import HomePage from './pages/HomePage';
import SolutionsPage from './pages/SolutionsPage';
import ProductsPage from './pages/ProductsPage';
import PokerProductsPage from './pages/PokerProductsPage';
import ClubAppPage from './pages/ClubAppPage';
import DemoPage from './pages/DemoPage';
import ContactPage from './pages/ContactPage';
import OfferPage from './pages/OfferPage';

function App() {
  return (
    <Box minH='100vh' display='flex' flexDirection='column'>
      <ScrollToTop />
      <Header />
      <Box flex='1'>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/solutions' element={<SolutionsPage />} />
          <Route path='/products' element={<ProductsPage />} />
          <Route path='/products/poker' element={<PokerProductsPage />} />
          <Route path='/products/club' element={<ClubAppPage />} />
          <Route path='/demo' element={<DemoPage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/partner-offer' element={<OfferPage />} />
        </Routes>
      </Box>
      <Footer />
      <ChatWidget />
    </Box>
  );
}

export default App;
